/*
创建者 魏强(2018.2.5)
金牌个人网店
*/
<template>
   <div id="new-shop-page">
      <!-- 金牌网店banner -->
      <banner v-if="personalUpAdv" :data="personalUpAdv"></banner>
      <div class="wrapper">
        <!-- 精品速递 -->
        <boutique-express v-if="jpsdGoodsAdvLeftList"
          :jpsdGoodsAdvRightList="jpsdGoodsAdvRightList"
          :jpsdGoodsAdvLeftList="jpsdGoodsAdvLeftList" >
        </boutique-express>

        <!-- 人气热推 -->
        <popular-hot
          :hotPersonalStoreList="hotPersonalStoreList"
          :hotPersonalStoreGoodList="hotPersonalStoreGoodList" >
        </popular-hot>

        <store-list v-if="storeList.length>0" :data="storeList"></store-list>

      </div>
   </div>
</template>
<script>
import {personal} from 'api/home';
import {parseAdvList} from 'utils/tool';
import banner from './banner';
import boutiqueExpress from './boutique-express';
import popularHot from './popular-hot';
import storeList from './store-list';
  export default {
    components:{
      banner,boutiqueExpress,popularHot,storeList
    },
    data(){
      return {
        personalUpAdv:[],
        jpsdGoodsAdvRightList:[],
        jpsdGoodsAdvLeftList:[],
        hotPersonalStoreList:[],
        hotPersonalStoreGoodList:[],
        storeList:[]
      }
    },
    created(){
      this.fetchData();
    },
    methods:{
      fetchData(){
        personal().then(json=>{
          if(json.resCode==1){
            let data = json.data;
            this.personalUpAdv= parseAdvList( data.personShopAdvertisementDTO.advList);
            this.jpsdGoodsAdvRightList=parseAdvList(data.personShopRightAdvertisementDTO.advList);
            this.jpsdGoodsAdvLeftList=parseAdvList(data.personShopLeftAdvertisementDTO.advList);
            let hotPersonalStore=data.personStoreGoodsDTO;
            this.hotPersonalStoreGoodList=hotPersonalStore.storeTagRelGoodsDTOList;
            this.hotPersonalStoreList=hotPersonalStore.storeDetailDTOList,
            this.storeList=data.storeDetailDTOList;
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?cf4cd4d0